export const JARGON_DICTIONARY: Record<string, { kidFriendly: string; description: string }> = {
  monitor: {
    kidFriendly: "Watch",
    description: "A helper that keeps an eye on your site so you don't have to keep refreshing it."
  },
  endpoint: {
    kidFriendly: "Address",
    description: "The link to your site, like https://mywebsite.com."
  },
  check_interval: {
    kidFriendly: "How Often To Check",
    description: "The pause time between our checks. Every 1 minute is super safe!"
  },
  http_status: {
    kidFriendly: "Is Website Loading",
    description: "Whether the site responds with a happy 'Yes, I'm working!' or an error code."
  },
  webhook: {
    kidFriendly: "Send To App",
    description: "A secret path to send alert alerts straight into Discord, Slack, or Telegram."
  },
  incident: {
    kidFriendly: "Problem",
    description: "An event where your address stopped loading properly."
  },
  assertion: {
    kidFriendly: "Look For This Text",
    description: "Specific text that must be on the page for us to count it as fully working."
  }
};

export const TYPE_METADATA = {
  website: {
    label: "Website",
    description: "Shopify, personal blog, or portfolio",
    defaultInterval: 1,
    defaultGrace: 2,
    icon: "🌐"
  },
  api: {
    label: "API",
    description: "Data feeds, mobile apps, databases",
    defaultInterval: 1,
    defaultGrace: 1,
    icon: "⚡"
  },
  server: {
    label: "Server",
    description: "Computers, host nodes, cloud storage",
    defaultInterval: 5,
    defaultGrace: 5,
    icon: "🖥️"
  },
  game: {
    label: "Game Server",
    description: "Minecraft, Roblox, multiplayer spaces",
    defaultInterval: 5,
    defaultGrace: 3,
    icon: "🎮"
  },
  other: {
    label: "Other",
    description: "General endpoints or custom links",
    defaultInterval: 5,
    defaultGrace: 5,
    icon: "📦"
  }
};
